import React, { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import {  useNavigate, useParams } from 'react-router-dom';
import { resetPasswordCheckUUID, resetPasswordConfirm  } from "../../api/auth.ts";
import { TranslatorContext } from "../../context/Translator";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import { LegendFieldComponent, LegendTextareaComponent, IconFieldComponent } from "../../components/fields";

import LogoComponent from "../../components/LogoComponent";

export default function ResetPasswordNewPasswordPage() {
  const { t } = useContext(TranslatorContext);
  const navigate = useNavigate();

  const { uuid } = useParams()
  const verificationCode = localStorage.getItem("verificationCode");

  const [passwordError, setPasswordErr] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  

  const [formData, setFormData] = useState({
    password: "",
    confirmPassword:''
    });

  const [displayPage, setDisplayPage] = useState(true);

  const [nombrePila, setNombrePila] = useState("");
  const [email, setEmail] = useState("");
  const [emailUsuario, setEmailUsuario] = useState("");
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);


  useEffect(() => {

    if(!uuid)
    setDisplayPage(false);
    else
    resetPasswordCheckUUID(uuid)
      .then((res) => {
        if (res.error === false) {
            setNombrePila(res.usuario_reset_password?.usuario_nombre || "");
            setEmail(res.usuario_reset_password?.usuario_email || "");
            const emailValue = res.usuario_reset_password?.usuario_email;
            if (emailValue) {
              setEmailUsuario(emailValue.split("@")[0]);
            } else {
              setEmailUsuario("");
            }
              
          setDisplayPage(true);
        } else {
          setDisplayPage(false);
        }
      })
      .catch((err) => {
        console.error("Error validating UUID:", err);
        setDisplayPage(false);
      })

  }, [uuid]);
 
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleValidation = (e)=>{
    const passwordInputValue = e.target.value.trim();
    const passwordInputFieldName = e.target.name;

    //for password
    if(passwordInputFieldName==='password'){
      const uppercaseRegExp   = /(?=.*?[A-Z])/;
      const lowercaseRegExp   = /(?=.*?[a-z])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&()*+._-])/;
      const minLengthRegExp   = /.{8,}/;
      const digitsRegExp      = /(?=.*?[0-9])/;
      const passwordLength =      passwordInputValue.length;
      const uppercasePassword =   uppercaseRegExp.test(passwordInputValue);
      const lowercasePassword =   lowercaseRegExp.test(passwordInputValue);
      const specialCharPassword = specialCharRegExp.test(passwordInputValue);
      const minLengthPassword =   minLengthRegExp.test(passwordInputValue);
      const digitsPassword =      digitsRegExp.test(passwordInputValue);

      // check password include nombrePila in uppercase
      const nombrePilaInPassword = passwordInputValue.toUpperCase().includes(nombrePila.toUpperCase());
      const emailInPassword = passwordInputValue.toUpperCase().includes(email.toUpperCase());
      const emailUsuarioInPassword = passwordInputValue.toUpperCase().includes(emailUsuario.toUpperCase());

      let errMsg ="";
      if(passwordLength===0){
              errMsg="Debe ingresar una contraseña";
      }else if(!uppercasePassword){
              errMsg="Debe contener al menos una Mayúscula";
      }else if(!lowercasePassword){
              errMsg="Debe contener al menos una Minúscula";
      }else if(!specialCharPassword){
              errMsg="Debe contener al menos un caracter especial";
      }else if(!minLengthPassword){
              errMsg="Debe contener al menos 8 caracteres";
      }else if(!digitsPassword){
              errMsg="Debe contener al menos un número";
      }else{
          errMsg="";
      }
      console.log(errMsg);
      setPasswordErr(errMsg);
    }
    // for confirm password
    if(passwordInputFieldName=== "confirmPassword" || (passwordInputFieldName==="password" && formData.confirmPassword.length>0) ){
      if(formData.confirmPassword!==formData.password)
      {
      setConfirmPasswordError("Las contraseñas no coinciden");
      }else{
      setConfirmPasswordError("");
      }
    }
}

  const handleSubmit = (e) => {
    
    e.preventDefault();

    e.preventDefault();
    try {
      setDisableSubmitButton(true)

      // Validar que no exista error de validación. passwordError y confirmPasswordError deben estar vacíos.
      // Además, realizar una doble validación de la cantidad minima de caracteres para evitar que se valide sin ingresar datos en los input.

      if(passwordError !== "" || confirmPasswordError !== ""){
        Swal.fire({icon: 'warning', text: "Las contraseñas no cumplen los requisitos mínimos." })
        setDisableSubmitButton(false)
        return;
      }

      if(!uuid){
        Swal.fire({icon: 'warning', text: "URL de recuperación de contraseña inválida." })
        setDisableSubmitButton(false)
        return;
      }

      resetPasswordConfirm(uuid, formData.password, formData.confirmPassword)
      .then((res) => {
        if( res.error === false ) {
            Swal.fire({icon: 'success', text: 'Contraseña actualizada correctamente.'});
          localStorage.setItem("verificationCode", "");
          navigate("/");
        } else {
            Swal.fire({icon: 'warning', text: res.msg })
          setDisableSubmitButton(false)
        }
      })


    } catch (err) {
        Swal.fire({title: 'Error', text: 'Error al realizar cambio de contraseña. Si el problema persiste contacte al administrador.' })
      setDisableSubmitButton(false)
    }

   
  };

  

  return (
    <div>
     { displayPage ?
        <div className="mc-auth" translate="no">
          {/* Header con logo */}
          <div className="mc-auth-header">
            <img src="/images/logo.png" alt="CRISTOUR" className="mc-auth-logo-header" />
            <div className="mc-auth-help">
              <div className="mc-auth-feature-icon">
                <img src="/images/support.png" alt="Soporte" />
              </div>
              <span>¿Necesitas ayuda?</span>
              <a href="mailto:contacto@cristourviajes.cl">contacto@cristourviajes.cl</a>
            </div>
          </div>

          {/* Contenedor principal */}
          <div className="mc-auth-container">
            {/* Contenedor único - Bienvenida y Formulario */}
            <div className="mc-auth-welcome">
              <div className="mc-auth-welcome-content">
                <h1 className="mc-auth-welcome-title">Nueva<br />contraseña</h1>
                <p className="mc-auth-welcome-subtitle">Crea una nueva contraseña segura para tu cuenta.</p>
              </div>

              {/* Formulario de nueva contraseña */}
              <div className="mc-auth-form-wrapper">
                <h2 className="mc-auth-form-title">Cambiar Contraseña</h2>
                <p className="mc-auth-form-subtitle">Ingresa tu nueva contraseña</p>

                <form className="mc-auth-form" onSubmit={handleSubmit} translate="no">
                  <div className="text-left text-sm font-semibold text-gray-600 mb-7">
                    <h5 className="mc-duel-text-title">Tu contraseña debe cumplir:</h5>
                    <ul className="mc-user-metalist">
                      <li><i className="material-icons">check</i><span>Mínimo de 8 carácteres.</span></li>
                      <li><i className="material-icons">check</i><span>Letra Mayúscula y Minúscula.</span></li>
                      <li><i className="material-icons">check</i><span>Caracter especial (#?!@$%^&+*.-)</span></li>
                      <li><i className="material-icons">check</i><span>Al menos un número.</span></li>
                    </ul>
                  </div>

                  <div className="mc-auth-input-group">
                    <IconFieldComponent 
                      icon="add_moderator" 
                      type="password" 
                      placeholder="Nueva contraseña" 
                      name="password" 
                      onChange={handleInputChange}    
                      onKeyUp={handleValidation} 
                      classes="w-100" 
                      passwordVisible 
                    />
                    {passwordError !== "" ? (
                      <p className="mt-2 px-2 py-1 bg-red-50 text-red-600 border border-red-100 rounded text-sm">{passwordError}</p>
                    ) : null}
                  </div>

                  <div className="mc-auth-input-group">
                    <IconFieldComponent 
                      icon="verified_user" 
                      type="password" 
                      placeholder="Confirmar contraseña" 
                      name="confirmPassword"  
                      onChange={handleInputChange}   
                      onKeyUp={handleValidation} 
                      classes="w-100" 
                      passwordVisible 
                    />
                    {confirmPasswordError !== "" ? (
                      <p className="mt-2 px-2 py-1 bg-red-50 text-red-600 border border-red-100 rounded text-sm">{confirmPasswordError}</p>
                    ) : null}
                  </div>

                  <ButtonComponent className="mc-auth-btn-submit" disabled={disableSubmitButton} type="submit">
                    CAMBIAR CONTRASEÑA
                  </ButtonComponent>

                  <AnchorComponent className="mc-auth-forgot-link" to="/login">
                    Volver a login
                  </AnchorComponent>
                </form>
              </div>
            </div>
          </div>

          {/* Footer con características */}
         
        </div>
       :
       <div className="mc-auth" translate="no">
          {/* Header con logo */}
          <div className="mc-auth-header">
            <img src="images/logo.png" alt="CRISTOUR" className="mc-auth-logo-header" />
            <div className="mc-auth-help">
              <div className="mc-auth-feature-icon">
                <img src="images/support.png" alt="Soporte" />
              </div>
              <span>¿Necesitas ayuda?</span>
              <a href="mailto:contacto@cristourviajes.cl">contacto@cristourviajes.cl</a>
            </div>
          </div>

          {/* Contenedor principal */}
          <div className="mc-auth-container">
            {/* Contenedor único - Error */}
            <div className="mc-auth-welcome">
              <div className="mc-auth-welcome-content">
                <h1 className="mc-auth-welcome-title">Código<br />inválido</h1>
                <p className="mc-auth-welcome-subtitle">El código ingresado no es válido o ha expirado.</p>
              </div>

              {/* Botón de retorno */}
              <div className="mc-auth-form-wrapper">
                <h2 className="mc-auth-form-title">Error</h2>
                <p className="mc-auth-form-subtitle">Por favor, intenta nuevamente</p>

                <AnchorComponent to="/recuperar-password" className="mc-auth-btn-submit" style={{display: 'inline-block', width: '100%', textAlign: 'center', padding: '14px 22px', textDecoration: 'none'}}>
                  VOLVER A INTENTAR
                </AnchorComponent>
              </div>
            </div>
          </div>

          {/* Footer con características */}
          
        </div>
     }
    </div>
  );
}